import React from "react";

import { ArrowBack } from "@mui/icons-material";
import { Box, Grid, Theme, Typography } from "@mui/material";
import { Outlet, useMatch, useNavigate } from "react-router-dom";
import { makeStyles, withStyles } from "tss-react/mui";

import { theme } from "@/theme/customTheme";
import { colors } from "@/theme/overrides/colors";

import HeaderSection from "./components/HeaderSection";
import NotesAndObservation from "../ClientProfile/components/Notes-and-observation/NotesAndObservation";

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflowY: "visible",
  },
  header: {
    fontSize: theme.typography.pxToRem(12),
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    color: colors.primary,
    cursor: "pointer",
  },
  headerIcon: {
    fontSize: theme.typography.pxToRem(12),
    marginRight: "10px",
  },
  navBar: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    margin: theme.spacing(0, 4),
  },
  noScroll: {
    overflowY: "auto",
  },
}));

const Root = withStyles(Grid, {
  root: {
    height: "100%",
    padding: theme.spacing(2),
  },
});

const FullGrid = withStyles(Grid, {
  root: {
    height: "100%",
  },
});

const ProfileGrid = withStyles(Grid, {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowX: "hidden",
  },
});

const ClientDetailsPage: React.FC = () => {
  const { classes } = useStyles();

  const navigate = useNavigate();
  const isProfilePathActive = !!useMatch("/clients/:id/profile");
  const isMessagePathActive = !!useMatch("/clients/:id/messages/*");
  const isModulesPathActive = !!useMatch("/clients/:id/modules/*");
  const shouldShowNotes =
    isProfilePathActive || isMessagePathActive || isModulesPathActive;

  const isBodyCompositionHistoryPathActive = !!useMatch(
    "/clients/:id/profile/body-composition-history"
  );
  const isBodyMeasurementHistoryPathActive = !!useMatch(
    "/clients/:id/profile/body-measurement-history"
  );

  function onGoBack() {
    const anchor = isBodyCompositionHistoryPathActive
      ? "body-composition"
      : isBodyMeasurementHistoryPathActive
      ? "body-measurement"
      : "";
    navigate(`profile#${anchor}`);
  }

  return (
    <Root container>
      <ProfileGrid item xs={shouldShowNotes ? 9 : 12}>
        {isBodyCompositionHistoryPathActive ||
        isBodyMeasurementHistoryPathActive ? (
          <Box className={classes.navBar}>
            <Typography className={classes.header} onClick={onGoBack}>
              <ArrowBack className={classes.headerIcon} /> Profile
            </Typography>
          </Box>
        ) : null}
        {/* Header section */}
        <HeaderSection />
        <Outlet />
      </ProfileGrid>
      {shouldShowNotes && (
        <FullGrid item xs={3}>
          <NotesAndObservation />
        </FullGrid>
      )}
    </Root>
  );
};

export default ClientDetailsPage;
